import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-281d473c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stopSend" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.props.button)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            class: "button-stop",
            type: "button",
            onClick: _ctx.open,
            onKeydown: _withKeys(_withModifiers(_ctx.open, ["prevent"]), ["space","enter"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.text) + "をやめる", 1)
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button-stop",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)), ["prevent"]), ["space","enter"]))
          }, [
            _createElementVNode("a", null, _toDisplayString(_ctx.text) + "をやめる", 1)
          ], 32))
    ]),
    _createElementVNode("div", {
      id: "modalOverlay",
      class: "overlay",
      style: _normalizeStyle({ display: _ctx.modalType })
    }, null, 4),
    _createElementVNode("div", {
      id: "modalWindowCancelSendItem",
      class: "modalwindow modal-stopSend",
      style: _normalizeStyle({ display: _ctx.modalType })
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text) + "をやめる", 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.text) + "をやめると、入力された内容は消えます。", 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.text) + "をやめますか？ ", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_AppButton, {
            onClick: _ctx.close,
            onKeydown: _withKeys(_withModifiers(_ctx.close, ["prevent"]), ["space","enter"]),
            buttonId: 'button-continue'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.text) + "を続ける ", 1)
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"]),
          _createVNode(_component_AppButton, {
            onClick: _ctx.quit,
            onKeydown: _withKeys(_withModifiers(_ctx.quit, ["prevent"]), ["space","enter"]),
            styled: 'is-accent',
            buttonId: 'button-stop'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.text) + "をやめる ", 1)
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"])
        ])
      ])
    ], 4)
  ], 64))
}